import React, { useEffect, useState } from "react";
import {
  FooterNovoConhecerLinksProps,
  NavItemProps,
} from "./FooterNovoConhecerLinks.types";
import { FooterLinksContent } from "./FooterNovoConhecerLinks.style";
import { sizesNovo } from "../../../utils/styled/_variables.styled";
import { tagCtaClick } from "../../../utils/tagManager";

export default function FooterNovoConhecerLinks({
  navigationLinks1,
  navigationLinks2,
  navigationLinks3,
  navigationLinks4,
  navigationLinks5,
  navigationLinks6,
  navigationLinks7,
}: FooterNovoConhecerLinksProps) {
  
  const [isDevice, setIsDevice] = useState(window.innerWidth < sizesNovo.tablet);

  const handleResize = () => {
    setIsDevice(window.innerWidth < sizesNovo.tablet);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

// Função para disparar o tagCtaClick
const handleTagCtaClick = (text: string) => {
  tagCtaClick({
    element_text: text,
    element_location: "Footer",
    content_id: "links-menu-footer",
    section_title: "Footer",
  });
};

  const NavItem: React.FC<NavItemProps> = ({ list }) => {
    if (!list || list.length === 0) return null;

    return (
      <>
        {list.map((navItem, index) => (
          <div key={index}>
            <h3>
              <a
                href={navItem.link}
                target={navItem.target}
                rel="noopener noreferrer"
                className="main-link"
                onClick={() => handleTagCtaClick(navItem.text)}
              >
                {navItem.text}
              </a>
            </h3>
            {navItem.firstLevelLinks && navItem.firstLevelLinks.length > 0 && (
              <div>
                {navItem.firstLevelLinks.map((subItem, subIndex) => (
                  <div key={subIndex}>
                    <a
                      href={subItem.subLink}
                      target={subItem.subTarget}
                      rel="noopener noreferrer"
                      className="sub-link"
                    >
                      {subItem.subText}
                    </a>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </>
    );
  };

  return isDevice ? (
    <FooterLinksContent>
      <div>
        <NavItem list={navigationLinks1} />
        <NavItem list={navigationLinks2} />
        <NavItem list={navigationLinks3} />
        <NavItem list={navigationLinks4} />
        <NavItem list={navigationLinks5} />
        <NavItem list={navigationLinks6} />
        <NavItem list={navigationLinks7} />
      </div>
    </FooterLinksContent>
  ) : (
    <FooterLinksContent>
      <div>
        <div>
          <NavItem list={navigationLinks1} />
        </div>
        <div>
          <NavItem list={navigationLinks2} />
        </div>
        <div>
          <NavItem list={navigationLinks3} />
        </div>
        <div>
          <NavItem list={navigationLinks4} />
        </div>
        <div>
          <NavItem list={navigationLinks5} />
        </div>
        <div>
          <NavItem list={navigationLinks6} />
        </div>
        <div>
          <NavItem list={navigationLinks7} />
        </div>
      </div>
    </FooterLinksContent>
  );
}
